// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__hDinF","options":"AnswerScale_options__1xsAe","selected":"AnswerScale_selected__3n0zw"};